import { useMutation } from "@tanstack/react-query";
import { QUERY_KEYS } from "../querykeys";
import { googleSignupApi } from "./authInvite.api";

export const useGoogleInviteSignupMutation = () => {
   return useMutation({
        mutationKey:[QUERY_KEYS.GOOGLE_SIGNUP],
        mutationFn: googleSignupApi
    })
}